import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from '@app-services/user/user.service';
import { AppConstants } from '../const/constent';
import { TenantConstant } from '@app-constants/tenant.constant';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '@app-environments/environment';
import { isUserAdmin } from '@app-helpers/functions';
@Injectable({
  providedIn: 'root'
})
export class CourseService {
  apiURL = AppConstants.APIURL
  tenant:any = TenantConstant.tenant;
  public courseData = new BehaviorSubject<Object>({});
  public coourseDAta$ = this.courseData.asObservable()
  constructor(private http: HttpClient, private userService: UserService,) {
    
   }

  // studentHeader(param: any){
  //   return new HttpHeaders()
  // .set('content-type', 'application/json')
  // .set('Access-Control-Allow-Origin', '*')
  // .append('ot-student', param?.id)

  // }

  studentHeader(param: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (param.customFilter) {
      Object.keys(param.customFilter.header).forEach(key => {
        headers = headers.append(key, !(key == 'ot-student' && this.tenant=='srichaitanya') ? JSON.stringify(param.customFilter?.header[key]): param.customFilter?.header[key])
      })
    }
    return headers

  }


  getOptions(param: any) {
    return new HttpParams({
      fromString: Object.entries(param?.customFilter?.filters).map(([key, val]) => `${key}=${val}`).join('&'),
    });

    // delete param.customFilter;
    // return new HttpParams({
    //   fromString: Object.entries(param).map(([key, val]) => `${key}=${val}`).join('&'),
    // });
  }

  getCourse(param: any, _userTypeId: number = 1) {
    let userData = this.userService.getMobileAndName();

    if (param.courseType == 'allCourse') {
      param.customFilter.filters.myCourse = 0
    } else {
      param.customFilter.filters.myCourse = 1
    }
    delete param.courseType;

    const header = this.studentHeader(param)
    const options = this.getOptions(param)
    let opts: any = {
      params: options,
      headers: header
    }
    if (_userTypeId == 1) {
      return this.http.get(this.apiURL.course, opts);
    } else {
      return this.http.get(`${this.apiURL.teachers}/${userData.userId}/course-list`, opts)
    }
  }

  getCourseDetails(courseId: any, userId?: any, userTypeId?:any, isRecordedCourse?:boolean) {
    let user = this.getUserData()
    if (userId) {
      if(userTypeId == 1) {
        if(!isRecordedCourse){
          return this.http.get(`${this.apiURL.course}/${courseId}?student=${userId}&student-enrolled=${user.userId}`);
          
        }else{
          let params = {
            filter:'all',
            subject:'',
            page: '1',
            limit:'10'
          }
          return this.http.get(`${this.apiURL.class}/student/${userId}/recorded-course/${courseId}`,{params:params});
        }
      } else {
        return this.http.get(`${this.apiURL.course}/${courseId}?teacher=${userId}`);
      }
    }
    return this.http.get(`${this.apiURL.course}/${courseId}?student-enrolled=${user.userId}`);
  }

  getUserData() {
    return this.userService.getMobileAndName();
  }

  getCourseChapters(courseId: any, examName: any, subjectName: any, userId: any,params?) {
    let query = '';
    if(examName && subjectName) {
      query = `?exam=${examName}&subject=${subjectName}`;
    }
    return this.http.get(`${this.apiURL.course}/${courseId}/chapters${query}`,{params:params});
  }

  getStudentAssignments(courseId: any, examName: any, subjectName: any, userId: any,params?) {
    let query = `?uamID=${userId}`;
    if(examName && subjectName) {
      query += `&exam=${examName}&subject=${subjectName}`;
    }
    let studentId = localStorage.getItem("studentid");
    return this.http.get(`${this.apiURL.course}/${courseId}/${studentId}/class-assignments${query}`,{params:params});
  }

   enrollCourse(data: any) {
    let user =  this.getUserData()
    let roles = this.userService.getUserRoles()

    let body = {
      "exams": data.exams,
      "grade": data.grade,
      "courses": data.id,
      "batches": data.batchId,
      "student": {
        "id": user.userId,
        "firstName": user.firstName,
        "lastName": user.lastName,
        "phone": user.phone
      },
      "status": "active",
      "roles":roles? roles:[]
    }
    return this.http.post(`${this.apiURL.courseEnroll}`, body);
  }

  getChapterRules(courseId: any, chapterId: any, gradeId: any) {
    let studentId = localStorage.getItem("studentid");
    return this.http.get(`${this.apiURL.course}/${courseId}/chapter/${chapterId}/rules?grade=${gradeId}&studentid=${studentId}`);
  }

  getQueryParams(params: any) {
    let httpParams = new HttpParams();

    Object.keys(params).forEach(k => {
      httpParams = httpParams.set(k, params[k]);
    });
    return httpParams
  }

  generateHeader(filter: any) {
    if (!filter?.header) {
      return
    } else {
      let headers: HttpHeaders = new HttpHeaders();
      Object.keys(filter.header).forEach(key => {
        if (filter?.header[key] && filter?.header[key] != undefined) {
          headers = headers.append(key, !(key == 'ot-student' && this.tenant=='srichaitanya') ? JSON.stringify(filter?.header[key]): filter?.header[key])
        }
      })
      return headers

    }

  }

  getTeacherCourses(teacherId: any, param: any) {
    // /teachers/609380c19dc708de33a77650/classes?type=past&limit=6&page=1
    const header = this.generateHeader(param?.customFilter);
    const options = this.getQueryParams(param?.customFilter?.filters);
    let opts;

    // headers: header
    opts = {
      params: options
    }

    let url = `${this.apiURL.teachers}/${teacherId}/courses`;
    return this.http.get(url, opts);
  }


  getCourseListFilter(_params: any = null, _userTypeId: number = 1) {
    let userData = this.userService.getMobileAndName();

    const _headerOpt: any = this.generateHeader(_params?.customFilter);
    const _paramOpt: any = this.getQueryParams(_params?.customFilter?.filters);
    let url: any;
    if (_userTypeId == 1) {
      url = `${this.apiURL.course}/${userData?.userId}/filters`;
      return this.http.get(url, { headers: _headerOpt, params: _paramOpt });
    } else {
      url = `${this.apiURL.teachers}/courses/${userData?.userId}/filters`;
      return this.http.get(url, { headers: _headerOpt, params: _paramOpt });
    }
  }

  getCourseScheduleFilterList = (_courseId: any, _params: any, userId:number = 0, userTypeId: number = 1) => {
    if(userTypeId == 1) {
      const _headerOpt: any = this.generateHeader(_params);
      let url = `${this.apiURL.course}/mycourse/subjects/${_courseId}`;
      return this.http.get(url, { headers: _headerOpt })
    } else {
      return this.http.get(`${this.apiURL.teachers}/classes/${userId}/filters?course=${_courseId}`)
    }
  }

  getCourseScheduleAvailableDates = (_courseId: any, userId:number = 0) => {
    return this.http.get(`${this.apiURL.teachers}/${userId}/class-dates?course=${_courseId}`);
  }

  getCourseProgressData = (_courseId: any, userId:number = 0, userTypeId: number = 1) => {
    return this.http.get(`${this.apiURL.class}/student/${userId}/course-progress/${_courseId}`);
  }
  getCourseBatch = (_courseId: any, userId:number = 0) => {
  return this.http.get(`${this.apiURL.course}/batches/${_courseId}`)
  }
}
